import { useParams } from '@reach/router';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ServiceInfo } from '../../components/services/ServiceInfo';
import { Layout } from '../../components/ui/Layout';
import { Spinner } from '../../components/ui/Spinner';
import { setActiveService } from '../../redux/actions/supplierServices';

const ServicesDetailScreen = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector(state => state.ui);
  const params = useParams();
  useEffect(() => {
    dispatch(setActiveService(params.PkServiciosProveedores));
  }, [dispatch, params.PkServiciosProveedores]);
  return (
    <Layout>
      <div style={{ marginTop: '2rem' }} />
      {loading ? <Spinner /> : <ServiceInfo />}
    </Layout>
  );
};

export default ServicesDetailScreen;
